import script from "./CourseEnrollModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CourseEnrollModal.vue?vue&type=script&setup=true&lang=js"

import "./CourseEnrollModal.vue?vue&type=style&index=0&id=66786710&lang=scss"

const __exports__ = script;

export default __exports__